const categoryColors = {
    "Yeast Protection": "#AEC6CF",  // pastel blue
    "Pesticide Reduction": "#FFB347",  // pastel orange
    "Detoxify the Biomass": "#B39EB5",  // pastel purple
    "Optimization of Aroma Biosynthesis": "#FF6961",  // pastel red
    "Organic Nutrition": "#77DD77",  // pastel green
    "Mixed Nutrition": "#FDFD96",  // pastel yellow
    "Inorganic Nutrition": "#FFB6C1",  // pastel pink
    "Yeasts for Alcoholic Fermentation": "#CFCFC4",  // pastel gray
    "Treatments Containing Selected Yeast Derivatives": "#B0E0E6",  // pastel powder blue
    "Aging Adjuvants": "#FFD1DC",  // pastel light pink
    "Pre-bottling Treatments": "#C7CEEA",  // pastel lavender
    "Oenological Enzymes": "#F49AC2",  // pastel raspberry
    "Bacteria for Malolactic Fermentation": "#FFB347",  // pastel orange
    "Vinification and Fining": "#B39EB5",  // pastel purple
    "Anti-oxidation Treatments": "#77DD77",  // pastel green
    "Riddling Adjuvants": "#FF6961",  // pastel red
    "Alternative Solution": "#FFD1DC",  // pastel light pink
    "Vegan-friendly Chitosan-based Fining Agents": "#FDFD96",  // pastel yellow
    "Fining Agents": "#FFB6C1",  // pastel pink
    "Stabilizers": "#CFCFC4",  // pastel gray
    "Treatments to Correct Specific Defects": "#B0E0E6",  // pastel powder blue
    "Microbiological Stabilization": "#F49AC2",  // pastel raspberry
    "Tannins": "#AEC6CF",  // pastel blue
    "Wood Substitutes": "#C7CEEA",  // pastel lavender
    "Filtration Additives": "#FFB347",  // pastel orange
    "Acidifiers": "#B39EB5",  // pastel purple
    "De-acidifiers": "#77DD77",  // pastel green
    "Other Acids": "#FF6961"  // pastel red
};

  
  export default categoryColors;
  